import {
  declarePluralStringWithPlaceholders,
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const PromptsDisplayed = declarePluralStringWithPlaceholders(
  "promptLibrary.promptsDisplayed",
  {
    strings: ({ promptCount }) => {
      return {
        one: `${promptCount} prompt displayed`,
        other: `${promptCount} prompts displayed`,
      };
    },
    comment:
      "The number of prompts displayed on screen. 'prompt' is the text input provided to AI model like GPT",
    placeholders: {
      promptCount: "the number of prompts",
    },
  }
);

export const PromptsRequestFailed = declareString(
  "promptLibrary.promptsRequestFailed",
  {
    text: "Sorry, we're having connection problems. Refresh your browser or come back later.",
    comment:
      "Announcement displayed on the screen when the request to fetch Copilot prompts from the server-side fails.",
  }
);

export const PromptGridDescription = declareString(
  "promptLibrary.promptGridDescription",
  {
    text: "Press Enter to insert a prompt.",
    comment:
      "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout. Enter in this context means keyboard's enter key.",
  }
);

export const PromptGridNoTeamsSuccessTitle = declareString(
  "promptLibrary.promptGridNoTeamsSuccessTitle",
  {
    text: "You don't have any team prompts yet",
    comment:
      "Aria description displayed when a user is not member of any group.",
  }
);

export const PromptGridNoTeamsSuccessDescription =
  declareStringWithPlaceholders(
    "promptLibrary.promptGridNoTeamsSuccessDescription",
    {
      text: ({ learnMore }) =>
        `Create a team to publish prompts within your organization. ${learnMore}`,
      comment:
        "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout.",
      placeholders: {
        learnMore: "Learn more link",
      },
    }
  );

export const PromptGridLearnMoreLinkLabel = declareString(
  "promptLibrary.promptGridLearnMoreLinkLabel",
  {
    text: "Learn more",
    comment: "Link label to learn more.",
  }
);

export const PromptGridNoTeamsSuccessButtonLabel = declareString(
  "promptLibrary.promptGridNoTeamsSuccessButtonLabel",
  {
    text: "Explore other prompts",
    comment: "Button label to explore other prompts.",
  }
);

export const PromptGridTeamsNoPromptsMemberSuccessTitle = declareString(
  "promptLibrary.promptGridTeamsNoPromptsMemberSuccessTitle",
  {
    text: "You don't have any team prompts yet",
    comment:
      "Aria description displayed when a user is not member of any group.",
  }
);

export const PromptGridTeamsNoPromptsMemberSuccessDescription = declareString(
  "promptLibrary.promptGridTeamsNoPromptsMemberSuccessDescription",
  {
    text: "If your team owner published prompts to your teams, you will find them here.",
    comment:
      "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout.",
  }
);

export const PromptGridTeamsNoPromptsMemberSuccessButtonLabel = declareString(
  "promptLibrary.promptGridTeamsNoPromptsMemberSuccessButtonLabel",
  {
    text: "Explore other prompts",
    comment: "Button label to explore prompts.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessTitle = declareString(
  "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessTitle",
  {
    text: "You don't have any team prompts yet",
    comment:
      "Aria description displayed when a user is not member of any team.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessDescription = declareString(
  "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessDescription",
  {
    text: "Go to Bookmarked then hover over a prompt to publish it to a team.",
    comment:
      "Aria description being read to users when prompt grid is focused. Prompt grid in this context is a UI control that renders a list of Copilot prompts in a grid layout.",
  }
);

export const PromptGridTeamsNoPromptsOwnerSuccessButtonLabel = declareString(
  "promptLibrary.promptGridTeamsNoPromptsOwnerSuccessButtonLabel",
  {
    text: "Publish prompts to teams",
    comment: "Button label to share prompts to a group.",
  }
);
